module.exports = __webpack_public_path__ + "static/media/NNL_283x140.bf70aa39.png";